export const SET_ROLE = "SET_ROLE";
export const RESET_ROLE = "RESET_ROLE";
